import './pages.css'
import emitter from './emitter'
import Header from '../layout/Header'
import Footer from '../layout/Footer'
import Breadcrumb from './Breadcrumb'
import Sidebar from '../layout/Sidebar'
import AxiosURL from '../../ApiService/AxiosURL'
import React, { useEffect, useState } from 'react'
import Sunburst from './Sunburst'
import data from './data'


import { ResponsiveContainer, LineChart, Line, BarChart,CartesianGrid, Tooltip,Legend, Bar, AreaChart, Area, XAxis, YAxis } from "recharts";  
import Wateramount from './Wateramount'

export default function DemoPlot() {

  let [sunburstData] = useState(data);
  let irricostAPI = 'farmers/irrigationCost';
  let demoYieldAPI = 'farmers/demo_yield';
  let waterUsedApi = 'farmers/SaticWaterUsedSaved';

  const [useWaterEffect, setWaterEffect] = useState([]);
  const [useDemoYield, setDemoYield]     = useState([]);
  const [useirrigCost, setIrrigCost]     = useState([]);
  const [useWaterData, setWaterData]     = useState([]);
  const [useLoading, setIsLoading]       = useState([]);

  useEffect (()=>{
    fetchDemoYield(demoYieldAPI);
    fetchDemoirrigcost(irricostAPI);
    fetchWaterData(waterUsedApi);
    const lister = emitter.addListener("sendFilterData",districtDataFilter)
    return ()=>lister.remove();
  },[])

  const fetchDemoYield = async(url)=>{
    try{
      const response = await AxiosURL.get(url);
      setDemoYield(response.data.data);
      
    }catch(error){
      console.log(error);
    }
  }
  const fetchDemoirrigcost = async(url)=>{
    try{
          const response = await AxiosURL.get(url);
          setIrrigCost(response.data.data);
    }catch(error){
      console.log(error);
    }
  }  

  const fetchWaterData = async(url)=>{
    try{
          const response = await AxiosURL.get(url);
          console.log(response)
          setWaterData(response.data.data);
    }catch(error){
      console.log(error);
    }
  }
  const districtDataFilter = async (distData)=>{
    if(distData.district == 0)
    {
      fetchDemoirrigcost(irricostAPI);
      fetchDemoYield(demoYieldAPI);
      fetchWaterData(waterUsedApi);
    }else{
      setIsLoading(true);
      const response = await AxiosURL.get(demoYieldAPI,{params:distData});
      setDemoYield(response.data.data);
      getDemoirrigcost(distData);
      getDataDemoWater(distData);
    }
  }
  const getDemoirrigcost = async(distData)=>{
    const irrigresponse = await AxiosURL.get(irricostAPI,{params:distData});
    setIrrigCost(irrigresponse.data.data);

  }

  const getDataDemoWater= async(distData)=>{
    const waterDataResponse = await AxiosURL.get(waterUsedApi,{params:distData});
    setWaterData(waterDataResponse.data.data);
  }


  return (
    <div className='wrapper card-body'>
    <Sidebar />
    <div className='main '>
      <Header />
      <main className='content'>
      <div className='container-fluid p-0'>
        {/* <Breadcrumb /><br/> */}
        <section className='row'>
           <div className='row'>
            <div className='col col-md-12'>
              <div className='card graphCard staticwaterData '>
                <div className='card-body scrollTreeGraph'>
                  <p><strong>Water Used & Saved Data</strong></p>
                      <Wateramount />
                </div>
              </div>
            </div>
           </div>


           <div className='row'>
           <div className='col-8'>
              <div className='card graphCard dynamicGraph'>
                <div className='card-body'>
                    <p><strong>Compared with Demo plot & Pragati Farmers Yields Y5 & Y6</strong></p>
                        <LineChart width={730} height={250} data={useDemoYield}
                            margin={{ top: 10, right: 30, left: 0, bottom: 0 }}>
                            <defs>
                              <linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
                                <stop offset="5%" stopColor="#00b3b3" stopOpacity={0.8}/>
                                <stop offset="95%" stopColor="#8884d8" stopOpacity={0.7}/>
                              </linearGradient>
                              <linearGradient id="colorPv" x1="0" y1="0" x2="0" y2="1">
                                <stop offset="5%" stopColor="#808000" stopOpacity={0.8}/>
                                <stop offset="95%" stopColor="#663300" stopOpacity={0.4}/>
                              </linearGradient>
                            </defs>
                            <XAxis dataKey="year" />
                            <YAxis />
                            <CartesianGrid strokeDasharray="3 3" />
                            <Tooltip />
                            <Legend/>
                            <Line type="monotone" dataKey="Average_Demo_Plot_Yield" stroke="#00b3b3"  fill="url(#colorUv)" unit=" kg/ha"/>
                            <Line type="monotone" dataKey="Average_Project_Farm_Yield" stroke="#663300"  fill="url(#colorPv)"  unit=" kg/ha"/>
                          </LineChart>
                    </div>

      
                </div>
      
              </div>
              <div className='col-4'>
              <div className='card graphCard dynamicGraph'>
                <div className='card-body'>
                <table class="table">
                  <thead>
                    <tr>
                      <th scope="col">Year</th>
                      <th scope="col" style={{ backgroundColor: '#00b3b3', color:"#000000"}}>Average Demo Plot Yield</th>
                      <th scope="col" style={{ backgroundColor: '#663300', color:"#000000"}}>Average Project Farm Yield</th>
                    </tr>
                  </thead>
                  <tbody>
                  {useDemoYield.map(( allData, index ) => {
                  if(allData.year != 0)
                  return (<tr key={index}>
                      <td >{allData.year}</td>
                      <td style={{ backgroundColor: '#00b3b3', color:"#000000", height:'4rem'}}>{allData.Average_Demo_Plot_Yield}</td>
                      <td style={{ backgroundColor: '#663300', color:"#000000"}}>{allData.Average_Project_Farm_Yield}</td>
                    </tr>)
                  })}
                  </tbody>
                </table>
                </div>
                </div>
            </div>
            </div>
          

          <div className='footer'>
            <Footer />
          </div>
        </section>

    </div>
  </main>
 </div>
</div>
  )
}
